import React from 'react';
import { Box, ButtonBase, Paper, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { EmptyState } from '../../../../components/empty-state';

interface KpiCardProps {
    label: string;
    value: React.ReactNode;
    icon: React.ReactNode;
    color: string;
    hint?: string;
    onClick?: () => void;
}

// Indicador com ícone colorido; quando clicável, leva à consulta filtrada
export function KpiCard({ label, value, icon, color, hint, onClick }: KpiCardProps) {
    const content = (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: '100%' }}>
            <Box sx={{ display: 'flex', p: 1, borderRadius: 2, color, bgcolor: alpha(color, 0.12), flexShrink: 0 }}>{icon}</Box>
            <Box sx={{ minWidth: 0 }}>
                <Typography variant="caption" color="text.secondary" fontWeight={600} noWrap component="div">{label}</Typography>
                <Typography variant="h5" fontWeight={700} lineHeight={1.2}>{value}</Typography>
                {hint && <Typography variant="caption" color="text.secondary" noWrap component="div">{hint}</Typography>}
            </Box>
        </Box>
    );

    return (
        <Paper
            sx={{
                height: '100%', overflow: 'hidden',
                transition: 'box-shadow 150ms ease-out, transform 150ms ease-out',
                ...(onClick && { '&:hover': { boxShadow: 4, transform: 'translateY(-2px)' }, '@media (prefers-reduced-motion: reduce)': { '&:hover': { transform: 'none' } } }),
            }}
        >
            {onClick
                ? <ButtonBase onClick={onClick} sx={{ width: '100%', height: '100%', p: 2, justifyContent: 'flex-start', textAlign: 'left' }}>{content}</ButtonBase>
                : <Box sx={{ p: 2, height: '100%', display: 'flex' }}>{content}</Box>}
        </Paper>
    );
}

export function ChartCard({ title, subtitle, empty, emptyMessage = 'Sem dados no período', height = 280, children }: {
    title: string; subtitle?: string; empty?: boolean; emptyMessage?: string; height?: number; children: React.ReactNode;
}) {
    return (
        <Paper sx={{ p: 2.5, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="subtitle1" fontWeight={700}>{title}</Typography>
            {subtitle && <Typography variant="caption" color="text.secondary">{subtitle}</Typography>}
            <Box sx={{ mt: 2, flex: 1, minHeight: height }}>
                {empty ? <Box sx={{ height: '100%', display: 'flex', alignItems: 'center' }}><Box sx={{ width: '100%' }}><EmptyState message={emptyMessage} /></Box></Box> : children}
            </Box>
        </Paper>
    );
}
